module.exports = __webpack_public_path__ + "img/boxUnloadS1Page.5328cb9e.png";